import { getResponseHeader } from '~/lib/utils/fetch';

export const useStreakHeader = () => {
  const streaks = useNomadStorage('streak', []);

  const gaming = useGamingStore();

  const update = (response) => {
    let val: number = -1;

    const streakHeader = getResponseHeader(
      response,
      AdamHeader.NomadGamingStreak
    );

    if (streakHeader) {
      val = parseInt(streakHeader, 0);
      createNewValue(val);
    }
  };

  const getToDayDate = () => {
    const date = new Date();
    const day = new Date(date.getTime()).toISOString();

    return day.slice(0, 10);
  };

  const createNewValue = (val: number) => {
    if (getNowDayItem()) return;
    const nowDay = getToDayDate();
    streaks.value = [
      ...streaks.value,
      { value: val, day: nowDay, showed: false },
    ];
  };

  const refreshHeaderValueFromStore = () => {
    if (gaming.streakHistory.length === 0 && gaming.streak === 1) {
      createNewValue(gaming.streak);
    } else {
      const lastDay = gaming.streakHistory[gaming.streakHistory.length - 1];
      const item = getNowDayItem();
      if (!item && lastDay.date.slice(0, 10) === getToDayDate().slice(0, 10)) {
        createNewValue(gaming.streak);
      }
    }
  };

  const clear = () => {
    const nowDay = getToDayDate();
    const item = streaks.value.find((item) => item.day === nowDay);

    if (item) {
      item.showed = true;
    }
  };

  const getNowDayItem = () => {
    const nowDay = getToDayDate();
    const item = streaks.value.find((item) => item.day === nowDay);
    return item;
  };

  const hasNewStreak = computed(() => {
    const item = getNowDayItem();

    if (!item) return false;

    return !item.showed;
  });

  const newValue = computed(() => {
    const nowDay = getToDayDate();
    const item = streaks.value.find((item) => item.day === nowDay);
    if (item) return item.value;
    return gaming.streak;
  });

  return {
    update,
    hasNewStreak,
    newValue,
    clear,
    refreshHeaderValueFromStore,
  };
};
